import { inject, injectable } from 'inversify';
import { ContestMapper } from '@Mapper/tournament/ContestMapper';
import { IMapper } from '@Mapper/IMapper';
import { TYPES } from '@Types';
import { RequestAction, RequestFailure } from '../RequestAction';
import { Contest, Nullable } from '@Models';
import CacheRepository from '../CacheRepository';
import { RequestContestsSuccess } from './response';
import { contest } from '@Api';
import { ApiClient } from '@Api';

@injectable()
export class ContestRepository extends CacheRepository<
  string,
  contest,
  contest,
  Contest
> {
  @inject(TYPES.Mapper.ContestMapper) private _contestMapper!: ContestMapper;
  @inject(TYPES.Api.ApiClient) private _apiClient!: ApiClient;

  constructor() {
    super({ key: `/tournament/contests` });
  }

  public async getAll({
    locale,
  }: {
    locale: Nullable<string>;
  }): Promise<RequestAction> {
    try {
      const contestsDto = await this._apiClient.tournament.getContests({
        locale: this._locale.getlocale(),
      });
      await this.setCachedEntities({ data: contestsDto, locale: locale });
      return new RequestContestsSuccess({
        payload: contestsDto.map((item) => this._contestMapper.map(item)),
      });
    } catch (error: any) {
      console.log('error', error);
      return new RequestFailure({ error: error });
    }
  }

  protected getMapper(): IMapper<string, contest, contest, Contest> {
    return this._contestMapper;
  }
}
